import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Landing.css';
import logo from '../assets/ims-logo.png';
import landingImage from '../assets/bg.png';
import Footer from '../components/Footer';
import { Box, Button, keyframes, Typography, TextField } from '@mui/material';
import API_BASE_URL from '../config';

const AdminSignin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${API_BASE_URL}/admin/signin`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });
  
      const data = await response.json();

      if (response.ok) {
        // Store the token in local storage
        setError(null);
        localStorage.setItem('token', data.token);
        // Redirect to the dashboard or another page
        navigate('/admin/dashboard');
      } else {
        console.error('Error signing in:', data.message);
        setError(data.message);
      }
    } catch (error) {
      console.error('Error signing in:', error);
    }
  };

  const handleBack = () => {
    navigate('/');
  };

  const handleSignUpRedirect = () => {
    navigate('/signup');
  };

  return (
    <Box sx={{
      height: '100vh',
      display: 'flex',
      backgroundColor: '#fff',
      flexDirection: { xs: 'column', md: 'row' },
      overflowY: 'auto'
    }}>
      {/* Left Section - Image Only */}
      <Box sx={{
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#FFFAF0'
      }}>
        <Box
          component="img"
          src={landingImage}
          alt="Collaboration"
          sx={{
            height: '50%'
          }}
        />
      </Box>

      {/* Right Section */}
      <Box sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: { xs: 4, md: 8 },
        maxWidth: 500,
        margin: '0 auto',
        width: '100%'
      }}>
        <Box
          component="img"
          src={logo}
          alt="IMS Logo"
          sx={{ 
            width: 120,
            mb: 4,
          }}
        />
        
        <Typography variant="h3" sx={{ 
          mb: 0,
          fontWeight: 700,
          color: '#2D2D2D'
        }}>
          Admin Use Only
        </Typography>

        <Box component="form" onSubmit={handleLogin} sx={{ mt: 3 }}>
          <TextField
            fullWidth
            label="Email"
            variant="outlined"
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{ 
              mb: 2,
              '& .MuiInputBase-root': {
                height: 56,
                padding: '0px 0px',
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'transparent'
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: 'transparent'
              },
              '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: 'transparent'
              },
              '& .MuiInputBase-input': {
                height: '100%',
                padding: 0
              }
            }}
          />
          <TextField
            fullWidth
            label="Password"
            type="password"
            variant="outlined"
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            sx={{ 
              mb: 0,
              '& .MuiInputBase-root': {
                height: 56
              }
            }}
          />
          <Typography 
            align="right" 
            sx={{ 
              mb: 2,
              color: '#FF7A7A',
              cursor: 'pointer',
              '&:hover': {
                textDecoration: 'underline'
              }
            }}
            onClick={handleSignUpRedirect}
          >
            
          </Typography>

          {error && (
            <Typography color="error" sx={{ mb: 2 }}>
              {error}
            </Typography>
          )}

          <Button
            fullWidth
            variant="contained"
            size="large"
            type="submit"
            sx={{
              py: 1.5,
              borderRadius: 3,
              background: 'linear-gradient(45deg, #FF7A7A 30%,rgb(255, 210, 180) 90%)',
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: '0 4px 12px rgba(255, 122, 122, 0.3)'
              }
            }}
          >
            Sign In
          </Button>
        </Box>

        <Box sx={{ mt: 4, display: 'flex', gap: 2 }}>
          <Button
            fullWidth
            variant="outlined"
            sx={{
              py: 1.5,
              borderRadius: 3,
              borderColor: '#FF7A7A',
              color: '#FF7A7A',
              '&:hover': {
                backgroundColor: '#FFF2F2',
                borderColor: '#FF6B6B'
              }
            }}
            onClick={handleBack}
          >
            Back
          </Button>
        </Box>
        <Footer sx={{ mt: 6 }} />
      </Box>
    </Box>
  );
};

export default AdminSignin;
